import styled from 'styled-components';

export const PageContainer = styled.div`
  min-height: 100vh;
  background: #010606;
`;

export const PageHero = styled.section`
  padding: 120px 24px 60px;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
`;

export const PageTitle = styled.h1`
  font-size: 44px;
  line-height: 1.2;
  font-weight: 600;
  color: #f7f8fa;
  margin: 0 0 16px 0;

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

export const PageSubtitle = styled.p`
  font-size: 18px;
  color: #f0f0f0;
  margin: 0;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
`;
